import { useCallback, useState } from "react"

interface UseConversationMetricRuleMetricPickerParams {
  selectedMetrics: string[]
  setSelectedMetrics: (metrics: string[]) => void
}

export function useConversationMetricRuleMetricPicker({
  selectedMetrics,
  setSelectedMetrics,
}: UseConversationMetricRuleMetricPickerParams) {
  const [isRuleMetricPickerOpen, setIsRuleMetricPickerOpen] = useState(false)
  const [tempRuleMetrics, setTempRuleMetrics] = useState<string[]>([])

  const openRuleMetricPicker = useCallback(() => {
    setTempRuleMetrics([...selectedMetrics])
    setIsRuleMetricPickerOpen(true)
  }, [selectedMetrics])

  const closeRuleMetricPicker = useCallback(() => {
    setIsRuleMetricPickerOpen(false)
  }, [])

  const handleToggleTempRuleMetric = useCallback(
    (metricName: string, isSelected: boolean) => {
      setTempRuleMetrics((prev) =>
        isSelected
          ? prev.includes(metricName)
            ? prev
            : [...prev, metricName]
          : prev.filter((m) => m !== metricName),
      )
    },
    [],
  )

  const handleApplyRuleMetrics = useCallback(() => {
    setSelectedMetrics(tempRuleMetrics)
    setIsRuleMetricPickerOpen(false)
  }, [setSelectedMetrics, tempRuleMetrics])

  return {
    closeRuleMetricPicker,
    handleApplyRuleMetrics,
    handleCancelRuleMetrics: closeRuleMetricPicker,
    handleToggleTempRuleMetric,
    isRuleMetricPickerOpen,
    openRuleMetricPicker,
    tempRuleMetrics,
  }
}
